import { components } from 'react-select';

export const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.847656 0H7.875C8.36719 0 8.61328 0.601562 8.25781 0.957031L4.75781 4.45703C4.53906 4.67578 4.18359 4.67578 3.96484 4.45703L0.464844 0.957031C0.109375 0.601562 0.355469 0 0.847656 0Z"
          fill="black"
        />
      </svg>
    </components.DropdownIndicator>
  );
};
